import { createContext } from 'react'
import type { Rule } from './Validations'
import type { FormMetadata, FormValueTypes, FormValues, ItemMetadata } from '.'

export interface IFormContext {
  form: FormValues
  hasFormInitialized: boolean
  errors: Record<string, string>
  formMetaData: FormMetadata
  setFormValue: (key: string, value: FormValueTypes, isUserAction: boolean) => void
  setFormArrayValue: (
    key: string,
    value: string | boolean | number | undefined,
    isUserAction: boolean
  ) => void
  removeFormArrayValue: (
    key: string,
    value: string | boolean | number,
    isUserAction: boolean
  ) => void
  deleteFormValue: (key: string, isUserAction: boolean) => void
  setFormValidation: (key: string, validations: Array<ReturnType<Rule>>) => void
  setFormMetaData: (metaData: Partial<FormMetadata>) => void
  setFormItemMetaData: (key: string, metaData: Partial<ItemMetadata>) => void
}
export const FormContext = createContext<IFormContext>({
  form: {},
  hasFormInitialized: false,
  errors: {},
  formMetaData: {
    submitted: false,
    formItems: {},
  },
  setFormValue: () => ({}),
  setFormArrayValue: () => ({}),
  removeFormArrayValue: () => ({}),
  deleteFormValue: () => ({}),
  setFormValidation: () => ({}),
  setFormMetaData: () => ({}),
  setFormItemMetaData: () => ({}),
})

export interface IFieldsetContext {
  isInsideFieldset: boolean
  inputs: string[]
}

export const FieldsetContext = createContext<IFieldsetContext>({
  isInsideFieldset: false,
  inputs: [],
})
